
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-08c8605a&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./RegisterResult.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./RegisterResult.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-08c8605a!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./RegisterResult.vue"),
  /* scopeId */
  "data-v-08c8605a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/public/RegisterResult.vue
// module id = 96
// module chunks = 1